import { createCustomAction } from "typesafe-actions";
import { AssetClassParameter } from "types/AssetClassParameter";

const ASSETCLASSPARAMETERS_DATA_LOAD = "ASSETCLASSPARAMETERS/ASSETCLASSPARAMETERS_DATA_LOAD";
const ASSETCLASSPARAMETERS_DATA_LOAD_SUCCESS =
  "ASSETCLASSPARAMETERS/ASSETCLASSPARAMETERS_DATA_LOAD_SUCCESS";
const ASSETCLASSPARAMETERS_DATA_LOAD_FAIL =
  "ASSETCLASSPARAMETERS/ASSETCLASSPARAMETERS_DATA_LOAD_FAIL";

export type AssetClassParametersContentType = "all";

export const load = createCustomAction(ASSETCLASSPARAMETERS_DATA_LOAD, (type) => () => ({
  type,
}));

export const loadSuccess = createCustomAction(
  ASSETCLASSPARAMETERS_DATA_LOAD_SUCCESS,
  (type) => (data?: AssetClassParameter[]) => ({
    type,
    data,
  })
);

export const loadFail = createCustomAction(
  ASSETCLASSPARAMETERS_DATA_LOAD_FAIL,
  (type) => (error?: string) => ({
    type,
    error,
  })
);
